<template>
  <div>
    <div id="head-contact" class="bg-grad">
      <h2 class="text-white text-center">
        {{ $t("quiSommesNous.header.title") }}
      </h2>
    </div>

    <!-- TITRE PRINCIPAL -->
    <div class="container mt-5">
      <h2 class="fw-bold display-6 text-primary">
        {{ $t("quiSommesNous.mainTitle") }}
      </h2>
    </div>

    <section class="container mt-4">
      <div class="senior-section">
        <!-- BLOC TEXTE 1 -->
        <div class="text-container">
          <p>{{ $t("quiSommesNous.block1.p1") }}</p>
          <p>{{ $t("quiSommesNous.block1.p2") }}</p>
          <p>{{ $t("quiSommesNous.block1.p3") }}</p>
          <p>{{ $t("quiSommesNous.block1.p4") }}</p>
        </div>

        <!-- SECTION SOINS & SOCIO-ESTHÉTIQUE -->
        <h2 class="fw-bold text-primary mt-5 mb-3">
          {{ $t("quiSommesNous.competencesComplementaires.title") }}
        </h2>

        <div class="text-container">
          <p>{{ $t("quiSommesNous.competencesComplementaires.p1") }}</p>
        </div>

        <!-- BLOC TEXTE 2 -->
        <div class="text-container mt-4">
          <p>{{ $t("quiSommesNous.block2.p1") }}</p>
          <p>{{ $t("quiSommesNous.block2.p2") }}</p>
          <p>{{ $t("quiSommesNous.block2.p3") }}</p>
          <p>{{ $t("quiSommesNous.block2.p4") }}</p>
        </div>

        <!-- SECTION : EQUIPE VÉHICULÉE -->
        <h2 class="fw-bold text-primary mt-5 mb-4">
          {{ $t("quiSommesNous.equipeVehiculee.title") }}
        </h2>

        <div class="row">
          <div class="col-12 d-flex align-items-center mb-3">
            <div class="icon-circle bg-primary me-3 flex-shrink-0">
              <i class="bi bi-car-front-fill text-white"></i>
            </div>
            <p class="mb-0 text-large">
              {{ $t("quiSommesNous.equipeVehiculee.list.item1") }}
            </p>
          </div>

          <div class="col-12 d-flex align-items-center mb-3">
            <div class="icon-circle bg-primary me-3 flex-shrink-0">
              <i class="bi bi-car-front-fill text-white"></i>
            </div>
            <p class="mb-0 text-large">
              {{ $t("quiSommesNous.equipeVehiculee.list.item2") }}
            </p>
          </div>

          <div class="col-12 d-flex align-items-center mb-3">
            <div class="icon-circle bg-primary me-3 flex-shrink-0">
              <i class="bi bi-car-front-fill text-white"></i>
            </div>
            <p class="mb-0 text-large">
              {{ $t("quiSommesNous.equipeVehiculee.list.item3") }}
            </p>
          </div>

          <div class="col-12 d-flex align-items-center mb-3">
            <div class="icon-circle bg-primary me-3 flex-shrink-0">
              <i class="bi bi-car-front-fill text-white"></i>
            </div>
            <p class="mb-0 text-large">
              {{ $t("quiSommesNous.equipeVehiculee.list.item4") }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- CALL TO ACTION -->
    <Cta />
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";
import { useI18n } from "vue-i18n";

import Cta from "@/components/Cta.vue";

export default {
  name: "QuiSommeNous",
  components: {
    Cta,
  },
  setup() {
    const { t } = useI18n();

    useHead(() => ({
      title: t("quiSommesNous.meta-data.title"),
      meta: [
        {
          name: "description",
          content: t("quiSommesNous.meta-data.desc"),
        },
      ],
    }));
  },
};
</script>

<style scoped>
#head-contact {
  color: white;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-circle {
  width: 55px;
  height: 55px;
  min-width: 55px;
  min-height: 55px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 26px;
}

.text-large {
  font-size: 1.1rem;
  line-height: 1.4;
}

.flex-shrink-0 {
  flex-shrink: 0;
}
</style>
